"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SolarWaterPumpingOffGridCreationRequest = void 0;
const solarWaterPumpingOffGridConstants_1 = require("../constants/solarWaterPumpingOffGridConstants");
class SolarWaterPumpingOffGridCreationRequest {
    constructor() {
        this.solarWaterPumpingOffGridConstants = new solarWaterPumpingOffGridConstants_1.SolarWaterPumpingOffGridConstants();
    }
}
exports.SolarWaterPumpingOffGridCreationRequest = SolarWaterPumpingOffGridCreationRequest;
